$(function() {

  const documentHeight = () => {
   const doc = document.documentElement
   doc.style.setProperty('--doc-height', `${window.innerHeight}px`) 
  }
  documentHeight()
  window.addEventListener('resize', documentHeight)


  const announcementBarHeight = $(".announcement-bar").css("height").replace('px', '');
  
  let drawerSize = window.innerHeight - announcementBarHeight;

  const pathname = window.location.pathname  
  if(pathname != "/"){
    $("#menu-drawer").css("height", drawerSize);
  }
});